export const showSuccess = (messages, detail) => {
    messages.current.show({
        life: 10000,
        severity: 'success',
        summary: 'Parabéns!',
        detail
    });
};

export const showInfo = (messages, detail) => {
    messages.current.show({
        life: 10000,
        severity: 'info',
        summary: 'Informativo',
        detail
    });
};

export const showWarn = (messages, detail) => {
    messages.current.show({
        life: 10000,
        severity: 'warn',
        summary: 'Atenção!',
        detail
    });
};

export const showError = (messages, detail) => {
    messages.current.show({
        life: 10000,
        severity: 'error',
        summary: 'Ups! Ocorreu um erro',
        detail
    });
};

export const clear = messages => {
    messages.current.clear();
};